import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-intro-card',
  templateUrl: './intro-card.component.html',
  styleUrls: ['./intro-card.component.css']
})
export class IntroCardComponent implements OnInit {

  @Input() data;
  
  constructor() { }

  ngOnInit(): void {
    this.convertData();
  }


  convertData(){
    let result = {};
    if(this.data){
      this.data.cardTitle? result['title'] = this.data.cardTitle : null;
      this.data.alt? result['alt'] = this.data.alt : null;
      this.data.imageUrl? result['imageUrl'] = this.data.imageUrl : null;
      return result;
    }else{
      return null;
    }
  }

  getTitle(){
    if(this.data && this.data.title){
      return this.data.title;
    }else{
      return null;
    }
  }

}
